<template>
  <div class="how-quoting-works-modal">
    <LsModal title="How Quoting Works" track-id="how_quoting_works_modal">
      <template #body>
        <LsNumberedList :items="items" />
      </template>
    </LsModal>
  </div>
</template>

<script>
import { LsModal, LsNumberedList } from '@/components/common';

export default {
  name: 'HowQuotingWorksModal',
  components: {
    LsModal,
    LsNumberedList,
  },
  data() {
    return {
      items: [
        `Select one or more services and fill in the details about your request.`,
        `A crew will be scheduled to inspect the work the next time they come out to mow your lawn.`,
        `The crew will submit a quote within 24 hours of their visit. The quote will include the service to be performed, a price and a suggested date to complete service.`,
        `After you approve the quote, the crew will be scheduled to complete the service on the agreed upon service.`,
      ],
    };
  },
};
</script>
